import {i18n} from '@/locales';

export default {
  methods: {
    readableTimescale(value) {
      let map = {
        ['ASAP']: i18n.t('ASAP'),
        ['1MONTH']: i18n.t('1 Month'),
        ['3MONTHS']: i18n.t('3 Months'),
      }
      return map[value];
    }
  }
}
